const t = "Naciśnij Tab, aby przejść do okienka popover", e = {
  triggerHint: t
};
export {
  e as default,
  t as triggerHint
};
